import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { UtilsService } from '../commons/utils.service';

declare let require: any;
const environmentJsonConfigs = require('../assets/environment-config.js');

export interface EnvironmentConfigModel {
  env: string;
  sso: SSOConfigModel;
  clients: ClientConfigModel;
  apis: ApiConfigModel;
}
export interface SSOConfigModel {
  issuer: string;
  logoutUrl: string;
  clientId: string;
  flow: string;
}
export interface ClientConfigModel {
  [id: string]: { url: string };
}
export interface ApiConfigModel {
  [id: string]: { url: string };
}
@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService {
  private _environmentConfigs = null;
  constructor(@Inject(DOCUMENT) private document: Document) {
    this._environmentConfigs = Object.keys(environmentJsonConfigs)
      .filter(urlPattern =>
        UtilsService.matchRegex(this.document.location.hostname, urlPattern)
      )
      .map(urlPattern => environmentJsonConfigs[urlPattern])[0];
  }
  getEnvironmentConfigs(): EnvironmentConfigModel | undefined {
    return this._environmentConfigs;
  }
}
